const Index = r => require.ensure([], () => r(require('./index.vue')), 'group-speechEvaluation')
const evaluationHome = r => require.ensure([], () => r(require('./evaluationHome.vue')), 'group-speechEvaluation')
const Answer = r => require.ensure([], () => r(require('./answer.vue')), 'group-speechEvaluation')
const result = r => require.ensure([], () => r(require('./result.vue')), 'group-speechEvaluation')
const analysis = r => require.ensure([], () => r(require('./analysis.vue')), 'group-speechEvaluation')

export default { //
  path: '/evaluation',
  component: Index,
  children: [{
      meta: {
        title: '英语水平测试'
      },
      path: 'home',
      name: 'home',
      component: evaluationHome
    },
    {
      meta: {
        title: '英语水平测试'
      },
      path: 'answer',
      name: 'answer',
      component: Answer
    },
    {
      meta: {
        title: '语言测评结果'
      },
      path: 'result',
      name: 'result',
      component: result
    },
    {
      meta: {
        title: '错题解析'
      },
      path: 'analysis',
      name: 'analysis',
      component: analysis
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/speechEvaluation/router.js